module.exports = __webpack_public_path__ + "img/pfb-35-27_750l.prt.375c4d82.jpg";